// 例：login.wam.classora.jp → "wam"
//      report.wam.classora.jp → "wam"
//      admin.login.wam.classora.jp → "wam"
const getBrandFromHostname = () => {
  const host = window.location.hostname; // e.g. login.wam.classora.jp
  const parts = host.split("."); // → ["login", "wam", "classora", "jp"]

  // login.wam.classora.jp のような構造であれば "wam" は index 1
  // admin.login.wam.classora.jp → "wam" は index 2

  const classoraIndex = parts.indexOf("classora");
  if (classoraIndex > 1) {
    return parts[classoraIndex - 1]; // ✅ classora の 1つ前が brand
  }

  return "default"; // fallback
};

export default getBrandFromHostname;